import { Heading, Text } from '../../styledComponents';
import styles from './Ftux.module.css';

type FtuxProps = {
  title: string;
  text: string;
  emoji: string;
  bgColor?: string;
};

export default function Ftux({ title, text, emoji, bgColor }: FtuxProps) {
  return (
    <div className={styles.container}>
      <div className={styles.emojiContainer} style={{ backgroundColor: bgColor }}>
        {emoji}
      </div>
      <Heading fontSize="20px" lineHeight="30px" textAlign="center" fontWeight="500">
        {title}
      </Heading>
      <Text fontSize="16px" textAlign="center">
        {text}
      </Text>
    </div>
  );
}
